module.exports = __webpack_public_path__ + "img/draganddrop-explanation-en.42319790.png";